import { createContext, useContext, type PropsWithChildren } from "react";

type OverlayContextValue = {
  portalElement: HTMLDivElement | undefined;
};

const OverlayContext = createContext<OverlayContextValue>({
  portalElement: undefined,
});

type OverlayProviderProps = PropsWithChildren & OverlayContextValue;

export const OverlayProvider = (props: OverlayProviderProps) => {
  const { portalElement, children } = props;

  return (
    <OverlayContext.Provider value={{ portalElement }}>
      {children}
    </OverlayContext.Provider>
  );
};

export function useOverlay() {
  return useContext(OverlayContext);
}

export default OverlayContext;
